import { useEffect, useState } from 'react';
import UsersManagementService from '../../services/userManagementApi/usersManagement.service';
import { Button, Search, TableColumns, TableColumnWidth } from '@veneer/core';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { useTranslation } from 'react-i18next';
import subRetailManagement from '../../services/agendaApi/subRetailManagement.service';
import { DataInfoList, FormFieldsSubRetail, IRetailList, ISelectCountries, ISubRetailIn } from '../../models/input/agendaApi/ISubRetail';
import { IGetCountriesListDto } from '../../models/dto/userManagementApi/IGetCountriesListDto';

export const columnsWidth: TableColumnWidth[] = [
    { columnId: "retail" },
    { columnId: "company" },
    { columnId: "subRetail" },
    { columnId: "tier" },
    { columnId: "pointOfSale" },
    { columnId: "update" },
    { columnId: "delete" }
];

export const initialColum2 = [
    {
        id: "retail",
        label: "Retail",
        sortable: true,
    },
    {
        id: "company", label: "Company",
        sortable: true,
    },
    {
        id: "subRetail", label: "Sub Retail",
        sortable: true,
    },
    {
        id: "tier", label: "Tier",
        sortable: true,
    },
    {
        id: "pointOfSale", label: "Point of sale",
        sortable: true,
    },
    { id: "update", label: "" }
]

const initialStateForm: FormFieldsSubRetail = {
    retailId: [],
    countryId: [],
    companyId: [],
    subRetailId: [],
    tierId: [],
    nameRetail: [],
    formatPosID: []
};

interface IformData {
    dataRetailList: ISelectCountries[],
    dataCountryList: ISelectCountries[],
    dataTierList: ISelectCountries[],
    dataSubRetailFormat: ISelectCountries[],
}

export default function SubRetailManagementLogic() {
    const [dataRetailList, setDataRetailList] = useState<ISelectCountries[]>([])
    const [dataCountries, setDataCountries] = useState<ISelectCountries[]>([])
    const [dataTier, setDataTier] = useState<ISelectCountries[]>([])
    const [dataFormatPos, setDataFormatPos] = useState<ISelectCountries[]>([])
    const [dataSubRetailInformationList, setDataSubRetailInformationList] = useState<DataInfoList[]>([])
    const [dataFiltered, setDataFiltered] = useState<DataInfoList[]>([])

    const [columns2, setColumns2] = useState<TableColumns[]>(initialColum2)
    const [dataToUpdate, setDataToUpdate] = useState<DataInfoList>({
        company_Name: '',
        country: '',
        id_Country: 0,
        id_Pos_Format: 0,
        id_Retail: 0,
        id_SubRetail: 0,
        id_Tier: 0,
        pos_Format: '',
        retail: '',
        sub_Retail: '',
        tier: ''
    })
    const [loadingTable, setLoadingTable] = useState(true)
    const languageID: any = useSelector((state: RootState) => state.languageId);
    const [loading, setLoading] = useState<boolean>(false);
    const [createSubRetailModal, setCreateSubRetailModal] = useState(false)
    const [updateSubRetailModal, setUpdateSubRetailModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [currentDataSelect, SetCurrentDataSelect] = useState<IformData>({
        dataRetailList: [],
        dataCountryList: [],
        dataTierList: [],
        dataSubRetailFormat: [],
    })
    const [formPointOfSale, setFormPointOfSale] = useState<FormFieldsSubRetail>(initialStateForm);
    const [formPointOfSaleUpdate, setFormPointOfSaleUpdate] = useState<FormFieldsSubRetail>(initialStateForm);
    const [t] = useTranslation("global");
    const [activeFilter, setActiveFilter] = useState<string | null>(null);

    useEffect(() => {
        if (dataSubRetailInformationList.length > 0) {
            const newData = initialColum2.map((item) => {
                if (item.id !== '' && item.id !== "update") {
                    return {
                        ...item,
                        label: t(`posManagement.${item.id}`),
                        filter: undefined
                    };
                }
                return item;
            });
            setColumns2(newData);
            mapDataToColumns(dataSubRetailInformationList, newData)
        } else {
            columns2.forEach((item) => {
                if (item.id !== '' && item.label !== "") {
                    item.label = t(`posManagement.${item.id}`)
                }
            })
        }
    }, [t, dataSubRetailInformationList])

    useEffect(() => {
        if (dataFiltered.length > 0) {
            const data: DataInfoList[] = mapDataToColumns(dataFiltered, initialColum2)
            setDataSubRetailInformationList(data)
        }
    }, [dataFiltered])

    const createFilter = (
        label: string,
        handlerClear: () => void,
        handlerFilter: (value: string) => void
    ) => (
        <div style={{ width: '80%' }}>
            <Search
                label={label}
                placeholder={`Buscar ${label}`}
                id={`table-filter-${label.replace(/\s+/g, '')}`}
                onClear={handlerClear}
                onChange={(e) => handlerFilter(e!.toString())}
            />
        </div>
    );



    const handleClearFilter = () => {
        setColumns2(initialColum2)
    };

    const getCountriesList = () => {
        UsersManagementService.getCountriesList().then(
            (result: IGetCountriesListDto[]) => {
                const updatedOptions = result.map((item) => ({
                    value: item.contryId,
                    label: item.countryName,
                }));
                setDataCountries(updatedOptions);
                SetCurrentDataSelect((prev: IformData) => {
                    prev.dataCountryList = updatedOptions
                    return prev
                })
            }
        );
    };

    const getTierList = () => {
        subRetailManagement.getTierList(languageID.value.toString()).then(
            (result: IRetailList[]) => {
                const updatedOptions = result.map((item) => ({
                    value: item.fieldID,
                    label: item.fieldValue,
                }));
                setDataTier(updatedOptions);
                SetCurrentDataSelect((prev: IformData) => {
                    prev.dataTierList = updatedOptions
                    return prev
                })
            }
        );
    }

    const getFormatList = () => {
        subRetailManagement.getFormatList(languageID.value.toString()).then(
            (result: IRetailList[]) => {
                const updatedOptions = result.map((item) => ({
                    value: item.fieldID,
                    label: item.fieldValue,
                }));
                setDataFormatPos(updatedOptions);
                SetCurrentDataSelect((prev: IformData) => {
                    prev.dataSubRetailFormat = updatedOptions
                    return prev
                })
            }
        );
    }

    const handleUpdatePointOfSale = (data: DataInfoList) => {
        const newData = {
            company_Name: data.company_Name.toString(),
            country: data.country.toString(),
            id_Country: Number(data.id_Country),
            id_Pos_Format: Number(data.id_Pos_Format),
            id_Retail: Number(data.id_Retail),
            id_SubRetail: Number(data.id_SubRetail),
            id_Tier: Number(data.id_Tier),
            pos_Format: data.pos_Format.toString(),
            retail: data.retail.toString(),
            sub_Retail: data.sub_Retail.toString(),
            tier: data.tier.toString(),
        }
        setDataToUpdate(newData)
        setFormPointOfSaleUpdate({
            retailId: [data.id_Retail.toString()],
            countryId: [data.id_Country.toString()],
            companyId: [data.company_Name.toString()],
            subRetailId: [data.sub_Retail.toString()],
            tierId: [data.id_Tier.toString()],
            nameRetail: [data.retail.toString()],
            formatPosID: [data.id_Pos_Format.toString()]
        })
        return (
            setUpdateSubRetailModal(true)
        )
    };
    const handleFilterChange = (data: DataInfoList[], field: keyof DataInfoList, value: string) => {
        const lowerCaseValue = value.toLowerCase();
        const filterArray = dataFiltered.filter((element: DataInfoList) => {
            const elementValue = element[field]?.toString().toLowerCase() || '';
            return elementValue.includes(lowerCaseValue);
        });

        const newData: DataInfoList[] = mapDataToColumns(filterArray, initialColum2);
        setCurrentPage(1)
        setDataSubRetailInformationList(newData);
    };

    function mapDataToColumns(dataArray: DataInfoList[], columns: TableColumns[]): any[] {
        const columnIdToFieldMap: { [key: string]: keyof DataInfoList } = {
            "retail": "retail",
            "company": "company_Name",
            "subRetail": "sub_Retail",
            "tier": "tier",
            "pointOfSale": "pos_Format"
        };
        return dataArray.map(data => {
            const resultObject: { [key: string]: any } = {};

            columns.forEach(column => {
                const field = columnIdToFieldMap[column.id];
                let value: string | number | React.ReactNode = "";

                if (field) {
                    if (column.id !== 'online') {
                        value = data[field];
                    }
                    if (column.filter === undefined) {
                        column.filter = createFilter(
                            column.label,
                            () => handleClearFilter(),
                            (value) => handleFilterChange(dataArray, field, value)

                        );
                    }
                } else {
                    switch (column.id) {
                        case "update":
                            value = (
                                <Button onClick={() => handleUpdatePointOfSale(data)} disabled={false}>
                                    {t('header.update')}
                                </Button>
                            );
                            break;
                        default:
                            value = "";
                            break;
                    }
                }

                resultObject[column.id] = value;
            });

            return resultObject;
        });
    }

    const getSubRetailInformationList = () => {
        subRetailManagement.getSubRetailInformationListPos(languageID.value.toString())
            .then(r => {
                try {
                    setDataFiltered(r)
                } catch (error) {
                    console.error('Error al cargar lista:', error);
                } finally {
                    setLoadingTable(false)
                }
            })
    }

    const getRetailList = () => {
        subRetailManagement.getRetailList()
            .then(
                (result: IRetailList[]) => {
                    const updatedOptions = result.map((item) => ({
                        value: item.fieldID,
                        label: item.fieldValue,
                    }));
                    setDataRetailList(updatedOptions);
                    SetCurrentDataSelect((prev: IformData) => {
                        prev.dataRetailList = updatedOptions
                        return prev
                    })
                }
            );
    }

    const handleChangeSearch = (
        value: string,
        dataRef: ISelectCountries[],
        setData: React.Dispatch<React.SetStateAction<any[]>>
    ) => {
        const dataCopy = dataRef || [];
        const filterArray = dataCopy.filter((element: ISelectCountries) => {
            const lowerCaseValue = value.toLowerCase();
            const elementValue = element.value?.toString().toLowerCase() || '';
            const elementLabel = element.label?.toString().toLowerCase() || '';

            return (
                elementValue.includes(lowerCaseValue) ||
                elementLabel.includes(lowerCaseValue)
            );
        });

        setData(filterArray);
    };

    const insertSubRetail = (params: ISubRetailIn) => {
        setLoading(true)
        setLoadingTable(true)
        subRetailManagement.insertSubRetail(params)
            .then(r => {
                setColumns2(initialColum2)
                if (r === 1) {
                    getSubRetailInformationList();
                }
            }).catch(err => {
                console.log('error ', err)
            }).
            finally(() => {
                setLoading(false)
                setLoadingTable(false)
                setCreateSubRetailModal(false)
            })
    }

    const updateSubRetail = (params: ISubRetailIn) => {
        setUpdateSubRetailModal(false)
        setLoading(true)
        setLoadingTable(true)
        subRetailManagement.updateSubRetail(params)
            .then(r => {
                setDataSubRetailInformationList([])
                if (r === 1) {
                    getSubRetailInformationList();
                }
            }).catch(err => {
                console.log('error ', err)
            }).
            finally(() => {
                setLoading(false)
                setLoadingTable(false)
            })
    }

    return {
        getCountriesList, getSubRetailInformationList, insertSubRetail, dataSubRetailInformationList, loadingTable, loading, formPointOfSale, setFormPointOfSale,
        formPointOfSaleUpdate, setFormPointOfSaleUpdate, updateSubRetail, currentDataSelect, setCreateSubRetailModal, createSubRetailModal,
        updateSubRetailModal, setUpdateSubRetailModal, dataCountries, dataRetailList, getRetailList, getTierList, dataTier,
        setDataCountries, setDataFormatPos, setDataRetailList, setDataTier, getFormatList, dataFormatPos, dataToUpdate, columns2, setCurrentPage, currentPage, handleChangeSearch
    }
}
